// extracted by mini-css-extract-plugin
module.exports = {"squareButton":"SquareButton_squareButton__2BQg3","Dark":"SquareButton_Dark__2oQSx","active":"SquareButton_active__1Ia5m"};